(ns frontend.view.nev.kyc.process-events
  (:require
   [frontend.subscription :as subscription]
   [frontend.logging :as logging]))

(defn close-subscription!
  [kyc-process-id on-success!]
  (subscription/close ::kyc-subscription
                      (fn [close-resp]
                        (logging/debug "Closed KYC subscription " kyc-process-id)
                        (when (fn? on-success!)
                          (on-success!)))))

(defn open-process-subscription!
  [kyc-process-id on-update! on-error!]
  (subscription/close
   ::kyc-subscription
   (fn [close-resp]
     (subscription/open
      ::kyc-subscription
      :view-subscription/kyc-process
      {:kyc-process-id kyc-process-id}
      (fn [resp]
        (let [updates (:entities resp)
              kyc-process (->> updates
                               (remove
                                (fn [e]
                                  (not= (:db/id e) kyc-process-id)))
                               (sort-by :common/updated-on)
                               (last))
              esign-process (->> updates
                                 (filter #(= :entity.type/esign-process (:entity/type %)))
                                 (last))
              signatory-updates (->> updates
                                     (filter #(= :entity.type/signatory (:entity/type %))))]
          (on-update! kyc-process esign-process signatory-updates)
          :ok))
      (fn [error]
        (if (fn? on-error!)
          (on-error! error)
          (logging/error "KYC subscription failed " error))
        :ok)))))
